import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ItemMenuModal } from 'src/app/models/item-menu-modal';

@Component({
  selector: 'app-menu-modal',
  templateUrl: './menu-modal.component.html',
  styleUrls: ['./menu-modal.component.scss']
})
export class MenuModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  itens: ItemMenuModal[] = [];

  constructor(public dialogRef: MatDialogRef<MenuModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.itens = this.data.itens;
  }

  selecionar(item: ItemMenuModal) {
    this.dialogRef.close(item);
  }

  fechar() {
    this.dialogRef.close();
  }

}
